import { getSelectClassNames } from 'components/atoms/Form/Select/helpers';
import uniq from 'lodash/uniq';
import type { FC } from 'react';
import { useState } from 'react';
import type { ActionMeta, Props as ReactSelectProps } from 'react-select';
import ReactSelect from 'react-select';

type TagsInputProps = Omit<ReactSelectProps, 'value' | 'onChange'> & {
  value?: string[];
  onChange: (value: string[], action?: ActionMeta<unknown>['action']) => void;
  resetInputOnAdd?: boolean;
  isError?: boolean;
};

export type TagOption = {
  label: string;
  value: string;
  isError?: boolean;
};

const TagsInput: FC<TagsInputProps> = ({
  value = [],
  onChange,
  inputValue,
  onInputChange,
  resetInputOnAdd = true,
  isError,
  ...rest
}) => {
  const [innerInputValue, setInnerInputValue] = useState('');

  const isControlled = inputValue != null;

  const onAdd = () => {
    const trimmed = (isControlled ? inputValue : innerInputValue).trim();
    if (!trimmed) return;
    if (resetInputOnAdd) {
      if (isControlled)
        onInputChange?.('', {
          action: 'input-change',
          prevInputValue: inputValue,
        });
      else setInnerInputValue('');
    }
    onChange(uniq([...value, trimmed]));
  };

  return (
    <ReactSelect
      placeholder=""
      {...rest}
      classNames={{
        ...getSelectClassNames({ isError }),
        multiValue: (provided) => {
          return 'px-2 bg-primary-25 border border-primary-100 rounded font-semibold text-main text-sm mr-2 items-center gap-1';
        },
        ...rest.classNames,
      }}
      unstyled
      styles={undefined}
      value={value.map((email: string) => ({
        label: email,
        value: email,
      }))}
      isMulti
      isClearable={false}
      menuIsOpen={false}
      inputValue={isControlled ? inputValue : innerInputValue}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onAdd();
        }
      }}
      onInputChange={(value, meta) => {
        if (meta.action === 'input-change') {
          onInputChange?.(value, meta);
          return setInnerInputValue(value);
        }
        if (meta.action === 'input-blur') {
          onAdd();
        }
      }}
      onChange={(tags, meta) => {
        const values = (tags as { value: string }[]).map((t) => t.value);
        onChange(values, meta.action);
      }}
    />
  );
};

export default TagsInput;
